import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface UnsavedChangesDialogProps {
  open: boolean
  isSaving: boolean
  saveBlockedReason: string | null
  onSave: () => void
  onDiscard: () => void
  onStay: () => void
}

export function UnsavedChangesDialog({ open, isSaving, saveBlockedReason, onSave, onDiscard, onStay }: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={isOpen => { if (!isOpen && !isSaving) onStay() }}>
      <DialogContent className="max-w-[480px] rounded-2xl p-8 gap-6 border-none shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold leading-[1.3] tracking-[0.015em] text-primary">
            Leave without saving?
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm font-normal leading-[1.6] tracking-[0.015em] text-primary">
          You have unsaved changes. Save them before leaving, or discard them.
        </DialogDescription>
        {saveBlockedReason && (
          <p className="text-sm text-destructive" role="alert" data-testid="unsaved-changes-save-blocked">
            Can't save yet: {saveBlockedReason}
          </p>
        )}
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onStay} disabled={isSaving} data-testid="unsaved-changes-stay-button">
            Stay
          </Button>
          <Button type="button" variant="destructive" onClick={onDiscard} disabled={isSaving} data-testid="unsaved-changes-discard-button">
            Discard
          </Button>
          <Button
            type="button"
            onClick={onSave}
            disabled={isSaving || saveBlockedReason !== null}
            data-testid="unsaved-changes-save-button"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
